import React from 'react';
import Hero from '../components/Hero/Hero';
import Clients from '../components/Clients/Clients';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Process from '../components/Process/Process';
import Industries from '../components/Industries/Industries';
import HomeTeam from '../components/HomeTeam/HomeTeam';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import CTA from '../components/CTA/CTA';
import Blog from '../components/Blog/Blog';
import Testimonials from '../components/Testimonials/Testimonials';

/**
 * HomePage - Landing/Home page with all hero sections
 */
export default function HomePage() {
  return (
    <>
      <Hero />
      <Clients />
      <About />
      <Services />
      <Process />
      <Industries />
      <HomeTeam />
      <WhyChooseUs />
      <CTA />
      <Blog />
      <Testimonials />
    </>
  );
}
